import { Box, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material';
import { WidgetProps } from '@rjsf/core';

export default function TableRowRadioGroupWidget({ label, value, schema, onChange }: WidgetProps) {
  return (
    <Stack direction="row" spacing={3} alignItems="center">
      <Box flex={1}>{label}</Box>
      <RadioGroup sx={{ flex: 1 }} row value={value ?? null} onChange={(e) => onChange(e.target.value)}>
        {schema.enum?.map((item: any) => (
          <FormControlLabel value={item} control={<Radio />} label={item} />
        ))}
      </RadioGroup>
    </Stack>
  );
}
